import { render, staticRenderFns } from "./ProductRegistrationListItem.vue?vue&type=template&id=3f464ea8&scoped=true&"
import script from "./ProductRegistrationListItem.vue?vue&type=script&lang=js&"
export * from "./ProductRegistrationListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductRegistrationListItem.vue?vue&type=style&index=0&id=3f464ea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f464ea8",
  null
  
)

export default component.exports